module.exports = __webpack_public_path__ + "static/media/Accreditation-3.7b82e85b.png";